import {ActionCompletionDialogComponent} from '../common/action-completion-dialog/action-completion-dialog.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit} from '@angular/core';
import {Details} from '../details/details';
import {MatDialog} from '@angular/material';
import {MatTableDataSource} from '@angular/material';
import {PreviewInfoDialogComponent} from './preview-info-dialog/preview-info-dialog.component';
import {SimpleConfirmActionDialogComponent} from '../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../services/toast-messages.service';

@Component({
  templateUrl: './refrigerator-transfer-details.component.html'
})
export class RefrigeratorTransferDetailsComponent extends Details implements OnInit {

  data: any;
  sapData: any;
  private command: any;
  public basicDetailsConfig: any;
  public canShow: boolean;
  public dataSource: MatTableDataSource<any>;
  public initializePage: boolean;
  public isLoading: boolean;
  public mainDataSections: any[];
  public commandID: number;
  user: any;

  public displayedColumns: string[] = [
    'applicant_sale_point_name',
    'applicant_sales_group_description',
    'applicant_serial_number_received',
    'date_completed',
    'recipient_sale_point_name',
    'main_id',
    'comments'
  ];

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              public commonService: CommonService,
              private matDialog: MatDialog,
              private router: Router,
              private toastMessagesService: ToastMessagesService) {
    super();

    this.initializePage = false;
    this.isLoading = true;
    this.canShow = false;
    this.dataSource = new MatTableDataSource<any>([]);
  }

  public ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(async (params) => {
      this.commandID = +params.get('id');
      await this.initUser();
      this.data = await this.commonService.getSimpleList(`refrigerator_transfer/web/${this.commandID}`);
      this.command = this.data[0];
      this.dataSource = new MatTableDataSource<any>(this.data);
      await this.initializeCommandDetails();
      await this.initializeSAPResponses();
      this.initializePage = true;
      this.isLoading = false;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async initializeCommandDetails() {
    this.canShow = this.authService.isUserBelongsTo('basicUser') || this.authService.isUserBelongsTo('transportManager');
    this.basicDetailsConfig = {
      actions: [],
      infoRow: [{
        title: 'Πληροφορίες Χρηστών',
        values: [
          {
            title: this.command.created_by_name,
            value: 'Δημιουργήθηκε από'
          },
          {
            title: this.command.routed_by_name ? this.command.routed_by_name : '-',
            value: 'Δρομολογήθηκε από'
          },
          {
            title: this.command.canceled_by_name ? this.command.canceled_by_name : '-',
            value: 'Ακυρώθηκε από'
          }
        ]
      },
        {
          title: 'Ημερομηνίες',
          values: [
            {
              title: this.commonService.formatDateTime(this.command.date_created),
              value: 'Δημιουργήθηκε στις'
            },
            {
              title: this.commonService.formatDateTime(this.command.date_routed),
              value: 'Δρομολογήθηκε στις'
            },
            {
              title: this.commonService.formatDateTime(this.command.date_canceled),
              value: 'Ακυρώθηκε στις'
            }
          ]
        },
        {
          title: 'Πληροφορίες Σειριακού',
          values: [
            {
              title: this.command.applicant_serial_number,
              value: 'Αποστολή Ψυγείου'
            },
            {
              title: this.command.applicant_serial_number_material_id,
              value: 'Κωδικός Είδους'
            },
            {
              title: this.command.applicant_serial_number_material_name,
              value: 'Περιγραφή Είδους'
            }
          ]
        }
      ],
      status_name: this.command.status_description,
      status_value: this.command.status_id === 4 ? 1 : 0,
      subtitle: [
        {
          title: 'Α/Α Εντολής',
          value: this.command.id
        }
      ],
      title: 'Πληροφορίες Αλληλομεταφοράς'
    };
    await this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];
    const action = {
      function: () => {
        this.downloadPDF();
      },
      showAction: this.canShow,
      title: 'Λήψη PDF',
      icon: 'picture_as_pdf',
      color: '#013e81',
    };

    const action1 = {
      function: () => {
        this.cancelTransfer('cancel');
      },
      showAction: this.command.status_id === 1,
      title: 'Ακύρωση Αλληλομεταφοράς',
      icon: 'cancel',
      color: 'red',
      tooltip: 'Η εντολή πρέπει να είναι Εκκρεμής'
    };

    const action2 = {
      function: () => {
        this.cancelTransfer('refuse');
      },
      showAction: this.command.status_id === 10,
      title: 'Άρνηση Παραλαβής',
      icon: 'cancel',
      color: 'red',
      tooltip: 'Η εντολή πρέπει να είναι Δρομολογημένη'
    };

    const action3 = {
      function: () => {
        this.previewData();
      },
      showAction: this.canShow,
      title: 'Προβολή δεδομένων SAP',
      icon: 'info',
      color: '#013e81'
    };

    actions.push(action1);
    actions.push(action2);
    actions.push(action);
    actions.push(action3);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
  }

  private async initializeSAPResponses() {
    try {
      this.sapData = await this.commonService.getSimpleList(`refrigerator_transfer/sap_response/${this.commandID}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(`Δε μπορέσαμε να φέρουμε τις πληροφορίες SAP.`);
    }
  }

  private async initUser() {
    this.user = await this.authService.getUser();
  }

  async downloadPDF() {
    try {
      await this.commonService.getPDF(`pdf?model=refrigerator_transfer&id=${this.commandID}`,
        `Αλληλομεταφορά Ψυγείου - ${this.commandID}`);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  private cancelTransfer(reason: string) {
    const data = reason === 'cancel' ? {title: 'Ακύρωση Αλληλομεταφοράς Ψυγείου', message: 'ακυρώσετε την αλληλομεταφορά '}
      : {title: 'Άρνηση Παραλαβής Ψυγείου', message: 'αρνηθείτε την παραλαβή '};
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: data.title,
        message: `Είστε σίγουροι ότι
        θέλετε να ${data.message} του ψυγείου ${this.command.applicant_serial_number};`
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          const response = await this.commonService.updateObject(`refrigerator_transfer/update/${this.commandID}`,
            {type: reason});
          if (response) {
            this.matDialog.open(ActionCompletionDialogComponent, {
              data: {
                buttonText: 'Πλοήγηση στις εντολές αλλημεταφοράς',
                redirectURL: `refrigerator_transfers`
              }
            });
          }
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  private previewData() {
    this.matDialog.open(PreviewInfoDialogComponent, {
      data: {
        return_info: this.sapData.sap_return ? JSON.parse(this.sapData.sap_return) : null,
        send_info: this.sapData.sap_send ? JSON.parse(this.sapData.sap_send) : null
      }
    });
  }

  public setTableHeight(): number {
    return window.innerHeight - 403;
  }

  protected showActions(): boolean {
    return true;
  }
}
